import { useEffect, useState } from 'react';
import { useMutation } from 'react-query';
import { showNotification } from '../../../actions/index';
import { api } from '../../../api';

const useEnableDQP = ({
  currentCenterId,
  centerDqpCourierEnabled,
  centerDqpExpressEnabled,
  centerDqpExpressPrioEnabled,
  // frichtiDqpExpressEnabled,
  frichtiDqpExpressPrioEnabled,
  dispatch,
}) => {
  const [frichtiDQPExpressPrioIsEnabled, setFrichtiDQPExpressPrioIsEnabled] = useState(frichtiDqpExpressPrioEnabled);
  // const [frichtiDQPExpressIsEnabled, setFrichtiDQPExpressIsEnabled] = useState(frichtiDqpExpressEnabled);
  const [centerDQPCourierIsEnabled, setCenterDQPCourierIsEnabled] = useState(centerDqpCourierEnabled);
  const [centerDQPExpressPrioIsEnabled, setCenterDQPExpressPrioIsEnabled] = useState(centerDqpExpressPrioEnabled);
  const [centerDQPExpressIsEnabled, setCenterDQPExpressIsEnabled] = useState(centerDqpExpressEnabled);

  // useEffect(() => {
  //   setFrichtiDQPExpressIsEnabled(frichtiDqpExpressEnabled);
  // }, [frichtiDqpExpressEnabled]);

  useEffect(() => {
    setFrichtiDQPExpressPrioIsEnabled(frichtiDqpExpressPrioEnabled);
  }, [frichtiDqpExpressPrioEnabled]);

  useEffect(() => {
    setCenterDQPCourierIsEnabled(centerDqpCourierEnabled);
  }, [centerDqpCourierEnabled]);

  useEffect(() => {
    setCenterDQPExpressPrioIsEnabled(centerDqpExpressPrioEnabled);
  }, [centerDqpExpressPrioEnabled]);

  useEffect(() => {
    setCenterDQPExpressIsEnabled(centerDqpExpressEnabled);
  }, [centerDqpExpressEnabled]);

  const [mutateIsEnabled, { isLoading: isEnabledIsLoading }] = useMutation(({
    centerId, siteId, payload
  }) => (
    api.setCenterSiteDQPIsEnabled(centerId, siteId, payload)
  ),
  {
    onSuccess: (data, { siteId, payload }) => {
      const resolveLabel = () => {
        const frichtiPrefix = siteId === 1013 ? "Frichti Market " : "";

        if (payload.hasOwnProperty("dqp_express_enabled")) {
          return `${frichtiPrefix}EXPRESS DQP`;
        } else if (payload.hasOwnProperty("dqp_courier_enabled")) {
          return "DQP Coursier privé";
        } else if (payload.hasOwnProperty("dqp_express_prio_enabled")) {
          return `${frichtiPrefix}EXPRESS PRIO DQP`;
        }
      };
      const resolveStatus = () => {
        if (payload.hasOwnProperty("dqp_courier_enabled")) {
          return payload.dqp_courier_enabled;
        } else if (payload.hasOwnProperty("dqp_express_prio_enabled")) {
          return payload.dqp_express_prio_enabled;
        } else if (payload.hasOwnProperty("dqp_express_enabled")) {
          return payload.dqp_express_enabled;
        }
      };

      const label = resolveLabel() || "DQP setting";
      const status = resolveStatus();

      dispatch(showNotification('success', {
        title: label,
        message: status ? `${label} activé` : `${label} désactivé`,
        autoDismiss: 10,
        dismissible: "click",
      }));
    },
    onError: (error) => {
      console.error("Error updating DQP enabled:", error);
      setFrichtiDQPExpressPrioIsEnabled(!frichtiDQPExpressPrioIsEnabled);
    },
  });

  const handleFrichtiDQPExpressPrioToggle = (isEnabled) => {
    setFrichtiDQPExpressPrioIsEnabled(isEnabled);
    mutateIsEnabled({
      centerId: currentCenterId,
      siteId: 1013, // fm site id
      payload: {
        dqp_express_prio_enabled: isEnabled,
      },
    });
  };

  // const handleFrichtiDQPExpressToggle = (isEnabled) => {
  //   setFrichtiDQPExpressIsEnabled(isEnabled);
  //   mutateIsEnabled({
  //     centerId: currentCenterId,
  //     siteId: 1013, // fm site id
  //     payload: {
  //       dqp_express_enabled: isEnabled,
  //     },
  //   });
  // };

  const handleCenterDQPCourierToggle = (isEnabled) => {
    setCenterDQPCourierIsEnabled(isEnabled);
    mutateIsEnabled({
      centerId: currentCenterId,
      siteId: null,
      payload: {
        dqp_courier_enabled: isEnabled,
      },
    });
  };

  const handleCenterDQPExpressPrioToggle = (isEnabled) => {
    setCenterDQPExpressPrioIsEnabled(isEnabled);
    mutateIsEnabled({
      centerId: currentCenterId,
      siteId: null,
      payload: {
        dqp_express_prio_enabled: isEnabled,
      },
    });
  };

  const handleCenterDQPExpressToggle = (isEnabled) => {
    setCenterDQPExpressIsEnabled(isEnabled);
    mutateIsEnabled({
      centerId: currentCenterId,
      siteId: null,
      payload: {
        dqp_express_enabled: isEnabled,
      },
    });
  };

  return ({
    frichtiDQPExpressPrioIsEnabled,
    handleFrichtiDQPExpressPrioToggle,
    // frichtiDQPExpressIsEnabled,
    // handleFrichtiDQPExpressToggle,
    centerDQPCourierIsEnabled,
    handleCenterDQPCourierToggle,
    centerDQPExpressPrioIsEnabled,
    handleCenterDQPExpressPrioToggle,
    centerDQPExpressIsEnabled,
    handleCenterDQPExpressToggle,
    // isEnabledIsLoading,
  });
};

export default useEnableDQP;